import { render } from "./SimulationTour.vue?vue&type=template&id=7b50e162"
import script from "./SimulationTour.vue?vue&type=script&lang=js"
export * from "./SimulationTour.vue?vue&type=script&lang=js"

import "./SimulationTour.vue?vue&type=style&index=0&id=7b50e162&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__